/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Local Imports
*/

import { CheckFormik, Button } from './';

/**
 * Exports
*/

/**
 * 
 */
export function Submit(props) {
  /** Formik **/

  const { isFormikSubmitting } = CheckFormik(props.formik);
  
  /** Settings **/

  const config = {
    type: 'submit',
    disabled: props.disabled || isFormikSubmitting,
    ...props
  };

  /** Output **/

  return <Button { ...config } />;
}

Submit.propTypes = {
  label: PropTypes.string,
  formik: PropTypes.object
};

Submit.defaultProps = {
  label: 'Submit'
};